<template>
  <div>
    <v-row align="end" style="margin-bottom: 15px">
      <v-col cols="12"
        ><h2>
          {{ $t("delegation.delegationNewBasedOnDelegationOrder.title") }}
        </h2></v-col
      >
      <v-col cols="6"
        >{{ $t("delegation.delegationNewBasedOnDelegationOrder.chooseBaseDelegationOrder") }}<br />
        <span class="font-weight-bold" v-if="isDelegationOrderRequired">{{
          $t("delegation.delegationNewBasedOnDelegationOrder.delegationOrderRequired")
        }}</span>
      </v-col>
      <v-col cols="6">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-data-table :headers="headers" :items="delegationOrders" :search="search" class="elevation-1">
      <template #item="props">
        <tr>
          <td class="text-left">
            {{ !!props.item.number ? props.item.number : $t("components.documentNumber.notSet") }}
          </td>
          <td class="text-left">
            {{ !!props.item.delegated_user ? props.item.delegated_user : $t("global.notSet") }}
          </td>
          <td class="text-left">
            {{ !!props.item.date_start ? props.item.date_start : $t("global.notSet") }}
          </td>
          <td class="text-left">
            {{ !!props.item.date_end ? props.item.date_end : $t("global.notSet") }}
          </td>
          <td class="text-right">
            <v-tooltip bottom>
              <template #activator="{on}">
                <v-btn text icon v-on="on" @click="previewDelegationOrder(props.item)">
                  <v-icon>search</v-icon>
                </v-btn>
              </template>

              <span>{{ $t("delegation.delegationNewBasedOnDelegationOrder.previewDelegationOrderDetails") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template #activator="{on}">
                <v-btn
                  text
                  icon
                  v-on="on"
                  :disabled="!(props.item.delegationId == null && props.item.status === 3)"
                  v-on:click="chooseDelegationOrder(props.item)"
                >
                  <v-icon>send</v-icon>
                </v-btn>
              </template>

              <span v-if="props.item.delegationId == null && props.item.status === 3">{{ $t("global.choose") }}</span>
              <span v-else-if="props.item.status !== 3">{{ $t("delegation.delegationNewBasedOnDelegationOrder.onlyAcceptedOrders") }}</span>
              <span v-else>{{ $t("delegation.delegationNewBasedOnDelegationOrder.alreadyCreatedSettlement") }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      <template slot="no-data">
        <v-alert color="error" icon="warning">
          {{ $t("delegation.delegationNewBasedOnDelegationOrder.noData") }}
        </v-alert>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import downloadInNewWindow from "../../repository/downloadFile";

export default {
  name: "DelegationStartChooseOrderView",
  data: () => ({
    users: [],
    delegationOrders: [],
    search: ""
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("delegation.number"), value: "number" },
        { text: this.$t("delegation.delegated"), value: "delegated_user" },
        { text: this.$t("delegation.startDate"), value: "date_start" },
        { text: this.$t("delegation.endDate"), value: "date_end" },
        { text: "", value: "actions", sortable: false }
      ];
    },
    isDelegationOrderRequired() {
      let userProperty = this.$store.getters["userProperties"];
      if (userProperty.system_settings.delegation_order_type === 3) {
        return true;
      }
      return false;
    }
  },
  methods: {
    previewDelegationOrder: function(item) {
      downloadInNewWindow("delegation-order/document-preview?id=" + item.id);
    },
    chooseDelegationOrder: function(item) {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("delegation.delegationNewBasedOnDelegationOrder.confirm.content"),
        title: this.$t("delegation.delegationNewBasedOnDelegationOrder.confirm.title")
      });
      result.then(() => {
        //TODO KOMUNIKAT TRWA PRZETWARZANIE
        //alert("TODO IMPORT Z POLECENIA DELEGACJI");//TODO dispose/import delegation/importFromDelegationOrder

        this.$router.push({ path: "/delegation/new-from-order/" + item.id }); //TODO umiescic to w then na zaladowanie danych z polecenia delegacji
      });
    },
    goBack: function() {}
  },
  created() {
    this.axios({ url: "delegation/get-available-delegation-order" }).then(resp => {
      this.delegationOrders = resp.data;

      //
      // for (let index in resp.data) {
      //     this.delegationOrders.push({number: resp.data. resp.data[index].id, text: resp.data[index].text});
      // }
      // object.loading = false;
    });
  }
};
</script>

<style scoped></style>
